<template>
 <div>
    <a
      class="nav-link dropdown-toggle"
      href="#"
      id="navbarDropdownNotifications"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
      v-on:click.prevent="activateDropdown"
    >
      <span v-show="checkVariable(newNotification)">
        <i class="fas fa-bell text-danger"></i>
      </span>
      {{ $t('notifications') }}
    </a>
    <transition name="fade" mode="out-in">
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownNotifications">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div class="new-message-box" ref="newMessageBox">
                <template v-if="notifications && notifications.length > 0">
                  <div
                    v-for="(notify, index) in notifications"
                    :key="`${index}-${notify.id}`"
                    class="new-message-box-info"
                    v-on:click.prevent="markAsIndividualView(notify)"
                  >
                    <div class="info-tab tip-icon-info text-center"><i class="fas fa-user"></i></div>
                    <template v-if="!checkVariable(notify.leida_en)">
                      <div class="tip-box-icon text-info"><icon name="circle" size="fa-1x"></icon></div>
                    </template>
                    <div class="tip-box-alert">
                      <p class="title">{{ notify.nombre }}</p>
                      <p><small>{{ notify.descripcion }}</small></p>
                      <template v-if="checkVariable(notify.datos)">
                        <vue-weirdotab
                          :data="showContentMessage(notify)"
                          v-on:clickImg="applySelection"
                        ></vue-weirdotab>
                      </template>
                      <p><small>{{ notify.fecha }}</small></p>
                      <template v-if="checkVariable(notify.ruta_cliente)">
                        <a class="btn btn-link" v-on:click="goResource(notify.ruta_cliente)">
                          {{ $t('go_resource') }}
                        </a>
                      </template>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="new-message-box-info">
                    <div class="tip-box-alert">
                      <p class="title">{{ $t('no_update') }}</p>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
 </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Form from 'vform'

import IncludeHelperComponent from '../plugins/includeHelperComponent'

export default {
  extends: IncludeHelperComponent,
  data () {
    return {
      pageNotification: 1,
      createSignature: new Form({
        firma: null,
      }),
    }
  },
  computed: {
    ...mapGetters({
      authenticated: 'authCheck',
      authUser: 'authUser',
      faAuthCheck: 'faAuthCheck',
      resultAssignmentSelectionDate: 'resultAssignmentSelectionDate',
      newNotification: 'newNotification',
      notifications: 'notifications',
    }),
  },
  watch: {
    resultAssignmentSelectionDate: function (result) {
      if (this.checkVariable(result)) {
        this.$store.dispatch('getNotifications', { notifications: this.notifications, page: this.pageNotification })
      }
    },
    pageNotification: function (page) {
      this.$store.dispatch('getNotifications', { notifications: this.notifications, page })
      this.$emit('pageNotification', page)
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.$store.dispatch('getNotifications', { init: true, notifications: this.notifications, page: this.pageNotification })
      this.scroll()
    })
  },
  methods: {
    activateDropdown(e) {
      this.$store.dispatch('getEvent', null)

      return false
    },
    scroll() {
      if (!this.checkVariable(this.$refs.newMessageBox)) {
        return
      }

      this.$refs.newMessageBox.onscroll = e => {
        const { target } = e
        const scrollTop = target.scrollTop + target.offsetHeight
        if (scrollTop === target.scrollHeight) {
          this.pageNotification++
        }
      }
    },
    /**
     * @param {Object} notify
     */
    markAsIndividualView(notify) {
      if (!this.checkVariable(notify.leida_en)) {
        this.$set(notify, 'leida_en', new Date())
        this.$store.dispatch('assignSelectionDate', notify.id)
      }
    },
    /**
     * @param {Object} notify
     */
    applySelection(notify) {
      const { value_apply, ruta_servidor  } = notify

      return this.storeSelection({ ruta_servidor, form: this.createSignature, selected: value_apply })
    },
    storeSelection(event) {
      const { selected, form, ruta_servidor } = event
      const promise = this.createSignatureWithSelectionSale(ruta_servidor, form, selected)
      if (promise === false) {
        return false
      }
      promise.then(response => {
        this.swalTitle = 'Se ha aplicado correctamente. '
        if (response === false) {
          this.swalTitle = this.$t('error_message')
        }

        // Message
        this.defaultSettingsToastSwal()
        this.swalText = undefined
        this.positionedDialogToast()
      }).catch(error => {
        return error
      })

      return promise
    },
  },
}
</script>
